import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import { LastLogin } from '../generated-types';
import getLastLogin from '../services/lastLoginService';

const useLastLogin = (enabled = false): QueryResult<LastLogin | undefined> =>
    useQuery({
        queryKey: ['last-login'],
        queryFn: getLastLogin,
        enabled,
    });

export default useLastLogin;
